
import { createStore, get, set, del, keys } from 'idb-keyval';
const store = createStore('app-cache', 'http-cache');

export function formatPriceBR(value) {
  if (!value) return "R$ 0,00";

  // Garante que seja número. Em caso de string, converte.
  const numericValue = Number(value);

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numericValue);
}
export function formatCurrencyBR(value) {
  if (value === null || value === undefined || value === "") return "";

  // Se vier string "R$ 1.234,56", tenta primeiro extrair somente dígitos
  // e converte para número. Se já for número, ok.
  const numeric = typeof value === "number"
    ? value
    : parseCurrencyBR(value);

  // Formata como moeda BR
  return numeric.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
export function parseCurrencyBR(value) {
  if (!value) return 0;

  // Remove "R$", espaços e pontos de milhar. Substitui vírgula por ponto.
  let clean = value
    .toString()
    .replace(/\s/g, "")
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(",", ".");

  // Tenta converter para float
  let numeric = parseFloat(clean);
  if (isNaN(numeric)) {
    numeric = 0;
  }
  return numeric;
}

export function formatDateBR(dateString) {
  if (!dateString) {
    return ''; // Retorna uma string vazia para campos vazios
  }

  const date = new Date(dateString);

  if (isNaN(date)) {
    return ''; // Retorna uma string vazia para datas inválidas
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatDateBRV2(dateString) {

  if (typeof dateString !== 'string') {
    console.error('Erro: O valor fornecido não é uma string válida.', dateString);
    return 'Data inválida';
  }

  // Se já estiver no formato DD/MM/YYYY, retorna a própria string
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  const dateParts = dateString.split('-');

  // Verifica se a string está no formato esperado (YYYY-MM-DD)
  if (dateParts.length !== 3) {
    console.error('Erro: Formato de data inválido. Esperado: YYYY-MM-DD', dateString);
    return 'Data inválida';
  }

  const [year, month, day] = dateParts;

  // Verifica se os valores são números válidos e se o mês e o dia estão dentro dos intervalos corretos
  if (
    isNaN(year) || isNaN(month) || isNaN(day) ||
    year.length !== 4 ||
    month.length !== 2 || day.length !== 2 ||
    Number(month) < 1 || Number(month) > 12 ||
    Number(day) < 1 || Number(day) > 31
  ) {
    console.error('Erro: Valores inválidos na data.', dateString);
    return 'Data inválida';
  }

  return `${day}/${month}/${year}`;
}

export function scrollToTop(stepContentRef) {
  // Aguarda 300ms para garantir que a animação/renderização esteja completa
  setTimeout(() => {
    if (stepContentRef.current) {
      const top = stepContentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top,
        left: 0,

      });
    }
  }, 200);
};

// Gera a chave única igual ao seu esquema atual
const NS = 'storeCache:v1';
const makeKey = (endpoint, params = {}) => {
  const q = new URLSearchParams(params).toString();
  return `${NS}:${endpoint}${q ? `?${q}` : ''}`;
};


// Escreve (grande) no IndexedDB
export async function setCache(endpoint, params = {}, data, { etag = null, ttl = 5 * 60_000 } = {}) {
  const k = makeKey(endpoint, params);
  const payload = { data, etag, ts: Date.now(), ttl };
  try {
    await set(k, payload, store);
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[IDB][WRITE][ERROR]', k, e?.name, e?.message);
    return false;
  }
}

// Lê do IndexedDB
export async function getCache(endpoint, params = {}) {
  const k = makeKey(endpoint, params);
  try {
    const entry = await get(k, store);
    if (!entry) return null;
    const { data, etag, ts, ttl } = entry;
    const fresh = !ttl || (Date.now() - ts) < ttl;
    return { data, etag, fresh, ts, ttl };
  } catch (e) {
    console.error('[IDB][READ][ERROR]', k, e?.name, e?.message);
    return null;
  }
}

export async function clearCache(endpoint, params = {}) {
  const k = makeKey(endpoint, params);
  try {
    await del(k, store);
  } catch (e) {
    console.error('[IDB][DEL][ERROR]', k, e?.name, e?.message);
  }
}

export async function idbEvictOld(prefix = NS, max = 50) {
  try {
    const allKeys = await keys(store);
    const myKeys = allKeys.filter(k => String(k).startsWith(prefix));
    if (myKeys.length <= max) return;

    // Estratégia: remover as mais antigas (precisaria ler ts por key — aqui omitimos por simplicidade)
    // Você pode guardar um catálogo de chaves->ts em outra store se quiser LRU real.
    const toRemove = myKeys.slice(0, myKeys.length - max);
    await Promise.all(toRemove.map(k => del(k, store)));
  } catch (e) {
    console.error('[IDB][EVICT][ERROR]', e?.name, e?.message);
  }
}
/*export function getCache(endpoint, params = {}) {
  try {
    const raw = localStorage.getItem(key(endpoint, params));
    if (!raw) return null;
    const { data, etag, ts, ttl } = JSON.parse(raw);
    const fresh = !ttl || (Date.now() - ts) < ttl;
    return { data, etag, fresh };
  } catch { return null; }
}*/

/*export function setCache(endpoint, params = {}, data, { etag = null, ttl = 5 * 60_000 } = {}) {
  try {
    localStorage.setItem(key(endpoint, params), JSON.stringify({
      data, etag, ts: Date.now(), ttl
    }));
  } catch (e) {
    console.error('[CACHE][WRITE][ERROR]', {
      //key: k,
      endpoint,
      params,
      etag,
      ttl,
      message: e?.message,
      name: e?.name,
      code: e?.code,
      // alguns navegadores sinalizam quota excedida com DOMException name 'QuotaExceededError'
      isQuotaExceeded:
        e && (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    });
  }
}*/

/*export function clearCache(endpoint, params = {}) {
  localStorage.removeItem(key(endpoint, params));
}*/

